<template>
    <div class="container page">
            <CartDetails :order="order" :is-editable="false" :is-offer="true"/>
            <CartSummary :order="order" :is-offer="true"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CartDetails from '../components/cart/CartDetails';
import CartSummary from '../components/cart/CartSummary';

export default {
  components: {
    CartDetails,
    CartSummary,
  },
  mounted() {
    this.disableNavBar();
    this.getOrder();
  },
  computed: {
    ...mapGetters({
      order: 'orders/order',
    }),
  },
  watch: {
    '$route.params.id'() {
      this.getOrder();
    },
  },
  methods: {
    getOrder() {
      return this.$route.params.id ? this.$store.dispatch('orders/getOffer', this.$route.params.id) : null;
    },
    disableNavBar() {
      this.$store.commit('navbar/navbarDisabled', true);
      this.$store.commit('navbar/isNavbarVisible', false);
    },
  },
};
</script>
